import { render } from "./SecondLevelProject.vue?vue&type=template&id=c5c9f732"
import script from "./SecondLevelProject.vue?vue&type=script&lang=js"
export * from "./SecondLevelProject.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__